import React from 'react';
import Plot from './Plot';
import './Quiz.css';

class PlotList extends React.Component {
    
    render(){
      let { matches } = this.props;
      
      return (
        <div className="plot-container">
            <Plot title="Word Count" aspect="length" docs={matches}></Plot>
            <Plot title="Adjective Density" aspect="adjective_density" docs={matches}></Plot>
            <Plot title="Formality" aspect="f_score" docs={matches}></Plot>
            <Plot title="Numeric Density" aspect="prop_numbers" docs={matches}></Plot>
            <Plot title="Reading Level" aspect="flesch_kincaid" docs={matches}></Plot>
        </div>
      )
    }
}

export default PlotList;